import closestUpdates from './closestUpdates'
import mostBacked from './mostBacked'
import randomList from './randomList'

export default {
    randomList,
    mostBacked,
    closestUpdates
}